jQuery(function ($) {

  // Mobile Menu Toggle
  $('.header button').on('click', (e) => {
    $('.header').toggleClass('js-menu-open');
  });

  // Mobile Menu Dropdowns
  $('.header').on('click', '.menu-item-has-children', (e)=>{
    if( $('.header').hasClass('js-menu-open') ) {
      $(e.currentTarget).toggleClass('open').find('.sub-menu').slideToggle();
    }
  });

  // CVaaS submenu sroll / highlighting
  $('.cvaas__sections__nav a').click((e)=>{
      e.preventDefault();
      var sectionTo = $(e.currentTarget).attr('href');
      $('html, body').animate({
        scrollTop: $(sectionTo).offset().top - 130
      }, 400);
  });

  function handler(entries, observer) {
    for (entry of entries) {
      if (entry.isIntersecting) {
        var currId = $(entry.target).attr('id');
        var $target = $('.cvaas__sections__nav').find(
          '[href="#' + currId + '"]'
        );
        if ($target.length) {
          $('.cvaas__sections__nav .active').removeClass('active');
          $target.parent().addClass('active');

          $container = $('.cvaas__sections__nav');
          $container.scrollLeft( $target.position().left + $container.scrollLeft() - 12 );
        }
      }
    }
  }
  if ('IntersectionObserver' in window) {
    let observer = new IntersectionObserver(handler, {
      rootMargin: '-50% 0px -50% 0px',
    });
    $('.cvaas__sections > section').each((i, el) => {
      observer.observe(el);
    });
  } else {
    $('.cvaas__sections__nav .active').removeClass('active');
  }

  // AOS
  function aosHandler(entries, observer) {
    entries.forEach((entry) => {
      if( entry.isIntersecting || entry.boundingClientRect.top < 0 ) {
        entry.target.classList.add('in-view');
      } else {
        entry.target.classList.remove('in-view');
      }
    });
  }
  let observer = new IntersectionObserver(aosHandler, {
    rootMargin: '0px 0px -25% 0px'
  });

  document.querySelectorAll('section, aside').forEach((el)=>{
    observer.observe(el);
  });

  // Video BG Fix
  $('.video-pre').each((i,el)=>{
    
    $(el).prepend('<canvas>');
    var vid = $(el).find('video')[0];

    vid.play();

    var wrapper = $(el).parents('section')[0];
    var canvas = $(el).find('canvas')[0];
    var ctx = canvas.getContext('2d');

    var ratio = window.devicePixelRatio || 1;
    var vidWidth;
    var vidHeight;

    vid.onloadedmetadata = function() {
      vidWidth = vid.videoWidth;
      vidHeight = vid.videoHeight;

      canvas.width = Math.floor(vid.offsetWidth * ratio);
      canvas.height = Math.floor(vid.offsetHeight * ratio);

      drawingLoop();

      setTimeout(() => {
        setVideoBgColor(vid, wrapper);
      }, 150);
    };

    function drawingLoop(){
      requestId = window.requestAnimationFrame(drawingLoop)

      ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                       0, 0, canvas.width, canvas.height); // destination rectangle);
    }

    function setVideoBgColor(vid, backgroundElement) {
      
                // draw first four pixel of video to a canvas
                // then get pixel color from that canvas
                var canvas = document.createElement("canvas");
                canvas.width = 8;
                canvas.height = 8;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(vid, 0, 0, 8, 8);

                var p = ctx.getImageData(0, 0, 8, 8).data;
                //dont take the first but fourth pixel [r g b]
                backgroundElement.style.transition = '.2s';
                backgroundElement.style.backgroundColor = "rgb(" + p[60] + "," + p[61] + "," + p[62] + ")";
    }


    window.onresize = function(event) {
        vidWidth = vid.videoWidth;
        vidHeight = vid.videoHeight;

        canvas.width = Math.floor(vid.offsetWidth * ratio);
        canvas.height = Math.floor(vid.offsetHeight * ratio);

        //redraw canvas after resize
        ctx.drawImage(vid, 0, 0, vidWidth, vidHeight, // source rectangle
                       0, 0, canvas.width, canvas.height); // destination rectangle);
    };

  });

});
